import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import { PromoImage } from "../../common/CustomPromoSection";
import { CustomButton, OrDivider } from "../../common/FormElements";
import {
  containerStyle,
  leftSectionStyle,
  promoImageStyle,
  rightSectionStyle,
  titleRowStyle,
  titleTextStyle,
  imageStyle,
  descriptionTextStyle,
  signInButtonStyle,
  signUpButtonStyle,
  subtitleTextStyle,
} from "./PasswordResetConfirmation.styles";
import { routes } from "../../routes/routes";
import tickImage from "../../assets/landingPage/emailSentTick-icon.svg";

const PasswordResetConfirmation: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const orgId = localStorage.getItem("orgId");

  const [title, setTitle] = useState("Successful");
  const [description, setDescription] = useState(
    "Your password has been reset successfully."
  );
  const [isForgotPasswordFlow, setisForgotPasswordFlow] = useState(
    location.state?.isForgotPasswordFlow ?? true
  );
  const [image, setImage] = useState<string | undefined>(undefined);
  const [showButtons, setShowButtons] = useState(false);

  useEffect(() => {
    if (location.state?.title) setTitle(location.state.title);
    if (location.state?.description) setDescription(location.state.description);
    if (location.state?.image) setImage(location.state.image);
    if (location.state?.showButtons) setShowButtons(location.state.showButtons);

    if (location.state?.isForgotPasswordFlow)
      setisForgotPasswordFlow(location.state.isForgotPasswordFlow);
  }, [location.state]);

  return (
    <Box sx={containerStyle}>
      {/* Left Section */}
      <Box sx={leftSectionStyle}>
        <PromoImage sx={promoImageStyle} />
      </Box>

      {/* Right Section */}
      <Box sx={rightSectionStyle}>
        {isForgotPasswordFlow && (
          <Box sx={titleRowStyle}>
            <Typography variant="h2" sx={titleTextStyle}>
              {title}
            </Typography>
            {(image || title === "Successful") && (
              <Box display="flex" justifyContent="center" paddingLeft={3}>
                <img
                  src={image || tickImage}
                  alt="success"
                  style={imageStyle}
                />
              </Box>
            )}
          </Box>
        )}

        {isForgotPasswordFlow && (
          <>
            <Typography sx={descriptionTextStyle}>{description}</Typography>
            {showButtons && (
              <Box>
                <CustomButton
                  label="Sign In"
                  variant="contained"
                  onClick={() => navigate(`/${routes.public.signIn}`)}
                  sx={signInButtonStyle}
                />
                <OrDivider />
                <CustomButton
                  label="Sign Up"
                  variant="outlined"
                  onClick={() => navigate(`/${routes.public.signUp}`)}
                  sx={signUpButtonStyle}
                />
              </Box>
            )}
          </>
        )}

        {!isForgotPasswordFlow && (
          <Typography variant="subtitle2" gutterBottom sx={subtitleTextStyle}>
            {description}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default PasswordResetConfirmation;
